import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITooltipProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<ITooltipProps>>
): IComponentSchema<ITooltipProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Tooltip',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Tooltip,
    'x-component-props': {
      title: 'Tooltip text',
      placement: 'top',
      trigger: ['hover'],
      arrow: true,
      color: '',
      visible: true,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    properties: props?.properties || {},
  };
};
